export const brands = "/brand";
export const addBrands = "/brand";
export const deleteBrandById = "/brand/";
export const updateBrandById = "/brand/";
